import React from 'react';
import './App.css';
import SignIn from './components/signin/signin';
import { Route, Routes } from 'react-router-dom';
import ErrorPage from './components/ErrorPage/ErrorPage';
import { useSelector } from 'react-redux';
import { IUser } from './interface/IUser';
import ResponsiveAppBar from './components/ResponsiveAppBar/ResponsiveAppBar';
import Home from './components/home/home';
import Orders from './components/orders/orders';
import Tasks from './components/tasks/tasks';
import OrderLines from './components/orders/order-lines';
import ReportView from './components/ReportView/ReportView';
import ReportInfo from './components/ReportView/reportInfo';
import ProductItems from './components/productItems/ProductItems';
import ProductItem from './components/productItems/ProductItem';



function App() {  
  //const [counter, setCounter] = React.useState(0);
  // useEffect(() => {
  //   setTimeout(() => setCounter(counter + 1), 60000);
  //   console.log('setTimeout')

  // }, [counter]);



  const userinfo: IUser = useSelector((state: any) => state.user)
  return (
    <div className="App" >
      {userinfo?.isSignedIn ? <ResponsiveAppBar /> : <></>}
      <Routes>
        <Route path='/' Component={userinfo?.isSignedIn ? Home : SignIn} />
        <Route path='/home' Component={userinfo?.isSignedIn ? Home : SignIn} />
        <Route path='/orders' Component={userinfo?.isSignedIn ? Orders : SignIn} />
        <Route path='/orders/orderlines/:orderData' Component={userinfo?.isSignedIn ? OrderLines : SignIn} />
        <Route path='/tasks' Component={userinfo?.isSignedIn ? Tasks : SignIn} />
        <Route path='/reports/reportsInfo/:reportName' Component={userinfo?.isSignedIn ? ReportInfo : SignIn} />
        <Route path='/reports' Component={userinfo?.isSignedIn ? ReportView : SignIn} />
        <Route path='/Products' Component={userinfo?.isSignedIn ? ProductItems : SignIn} />
        <Route path='/Products/Products/:productId' Component={userinfo?.isSignedIn ? ProductItem : SignIn} />

        
        <Route path ='*'  Component={ErrorPage} />
        {/* <Route path ='*'  element={<Navigate to="/"/>} /> */}
      </Routes>
    </div>
  );
}

export default App;
